var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPriority1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 24,
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#999",
      fillOpacity: 1,
      strokeWidth: 0.0919748,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none"
    },
    d: "M12.195 20.828a1.275 1.275 0 0 0 .662-.185l6.646-4.037a1.275 1.275 0 0 0 .428-1.751 1.275 1.275 0 0 0-1.751-.428l-5.985 3.635-5.985-3.635a1.275 1.275 0 0 0-1.75.428 1.275 1.275 0 0 0 .427 1.75l6.646 4.038a1.275 1.275 0 0 0 .662.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#b3b3b3",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0919748,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none"
    },
    d: "M12.195 15.694a1.275 1.275 0 0 0 .662-.185l6.646-4.037a1.275 1.275 0 0 0 .428-1.751 1.275 1.275 0 0 0-1.751-.428l-5.985 3.635L6.21 9.293a1.275 1.275 0 0 0-1.75.428 1.275 1.275 0 0 0 .427 1.75l6.646 4.038a1.275 1.275 0 0 0 .662.185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      color: "#000",
      fill: "#ccc",
      fillOpacity: 1,
      stroke: "none",
      strokeWidth: 0.0919748,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      InkscapeStroke: "none"
    },
    d: "M12.117 10.427a1.275 1.275 0 0 0 .661-.185l6.647-4.038a1.275 1.275 0 0 0 .428-1.75 1.275 1.275 0 0 0-1.751-.428L12.117 7.66 6.132 4.026a1.275 1.275 0 0 0-1.751.427 1.275 1.275 0 0 0 .428 1.751l6.646 4.038a1.275 1.275 0 0 0 .662.185z"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriority1);
export default __webpack_public_path__ + "static/media/priority-1.3aadff1fb92cfa76f86f7d35b47085f0.svg";
export { ForwardRef as ReactComponent };